import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { ConfigService } from 'app/config/config.service';
import { userSchema } from 'app/agriculture/hooks/users/userSchema';
import { User } from 'app/agriculture/hooks/users/types';

export async function getUser({
    queryKey: [endpoint, { userId }],
}: {
    queryKey: [endpoint: string, { userId: number }];
}) {
    const instance = createAxiosInstance({ baseURL: ConfigService.apiUrlRoot });
    const { data } = await instance.get<unknown>(`${endpoint}${userId}/`);

    return userSchema.parse(data) as User;
}
